<template>
  <div class="form-wrap">
    <label :for="toKebabCase(name)">{{ name }}{{ !required ? ` (${$t('meta.optional')})` : '' }}</label>
    <v-select
      :id="toKebabCase(name)"
      class="form-select__select"
      :disabled="disabled"
      :selectable="selectable"
      :noDrop="disabled"
      :searchable="!disabled"
      :value="loading ? null : value"
      @input="$emit('input', $event)"
      :reduce="option => option.value"
      :data-testid="dataTestid"
      :placeholder="placeholder || computedPlaceholder"
      :options="options || []"
      :loading="loading"
      :filterable="!pagination.enabled"
      :multiple="multiple"
      @search="pagination.searchCallback"
      @open="onOpen"
    >
      <template v-slot:no-options="{ search, searching }">
        <span v-if="searching" v-html="$t('selects.noResults', { search })" />

        <em v-else>
          {{ $t('selects.typeToSearch', { search }) }}
        </em>
      </template>

      <template v-slot:search="{ attributes, events }">
        <input
          class="vs__search"
          :required="required && !value"
          v-bind="attributes"
          v-on="events"
          @invalid="handleInvalidField"
          :title="computedPlaceholder"
        />
      </template>
    </v-select>
  </div>
</template>

<script>
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'FormSelect',
  props: {
    dataTestid: { required: false, type: String },
    disabled: { default: false, required: false, type: Boolean },
    selectable: { required: false, type: Function },
    loading: { default: false, required: false, type: Boolean },
    multiple: { default: false, required: false, type: Boolean },
    name: { required: true, type: String },
    options: { required: false, type: Array },
    pagination: {
      default: () => ({ enabled: false, searchCallback: () => {} }),
      required: false,
    },
    placeholder: { required: false, type: String },
    required: { required: false, type: Boolean },
    value: { default: null, type: [String, Number, Array] },
  },
  mixins: [stringUtils],
  methods: {
    onOpen() {
      this.$nextTick(() => this.$refs.search.focus())
    },
    // We need to add a custom error message since the built-in HTML form validation
    // displays error messages using the browser language which might differ from the
    // language that is currently set in the app.
    handleInvalidField() {
      this.$nextTick(() => this.$refs.search.setCustomValidity(this.$t('meta.pleaseSelect')))
    },
  },
  computed: {
    computedPlaceholder() {
      if (this.disabled || this.loading) return this.placeholder || this.name
      if (!this.options || !this.options.length) return this.$t('meta.noOptions', { name: this.name })
      if (this.placeholder) return this.placeholder

      return `${this.$t('meta.choose', { name: this.name })}`
    },
  },
  watch: {
    value() {
      this.$nextTick(() => this.$refs.search.setCustomValidity(''))
    },
  },
}
</script>

<style scoped lang="scss">
.form-select {
  &__container {
    flex-grow: 1;
  }
}
</style>
